// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__bm8fB"};